import React from "react";
import CampaignListPage from "./CampaignListPage";
import "../../components/common/css/index.scss";

const CampaignListIndex = () => {
  return (
    <div className="list">
      <div className="listContainer">
        <CampaignListPage />
      </div>
    </div>
  );
};

export default CampaignListIndex;
